<div class="p-4 md:p-6" (click)="closeMenus()">
  <div class="mb-4 flex items-center justify-between gap-3">
    <h2 class="text-2xl md:text-[26px] font-bold text-[#0e1726] dark:text-white">Gestionar vehículos</h2>
    <button
      class="flex items-center gap-2 rounded-xl bg-[#0e1726] dark:bg-white/10 text-white text-sm font-semibold px-4 py-2 hover:opacity-90"
      (click)="goToCommandCenter()"
    >
      <svg class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M9 20l-5.5 2.5V7L9 4.5m0 15.5l6-2.5m-6 2.5V4.5m6 13l5.5 2.5V7L15 4.5m0 13V4.5m0 0L9 7" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
      Centro de comando
    </button>
  </div>

  <div class="mb-4 flex items-center gap-3">
    <div class="relative flex-1">
      <icon-search class="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
      <input
        [(ngModel)]="searchText"
        (input)="applyFilter()"
        type="text"
        placeholder="Buscar vehículo"
        class="w-full rounded-xl border border-gray-200 dark:border-white/10 bg-white dark:bg-white/5 pl-10 pr-4 py-2 text-sm text-gray-700 dark:text-white focus:outline-none focus:ring-2 focus:ring-primary"
      />
    </div>

    <button class="rounded-xl bg-primary text-black text-sm font-semibold px-4 py-2 hover:opacity-90" (click)="openAddVehicle()">+ Agregar vehículo</button>
   <!-- <app-add-vehicle #addVehicleRef></app-add-vehicle> -->
  </div>

  <div class="space-y-3">
    <div
      *ngFor="let v of filtered; let i = index"
      class="flex items-center justify-between rounded-xl bg-white dark:bg-white/5 shadow-sm border border-gray-100 dark:border-white/10 px-4 py-4"
    >
      <div class="flex items-center gap-4">
        <div class="h-16 w-24 rounded-xl bg-gradient-to-br from-slate-200 to-slate-300 dark:from-white/10 dark:to-white/5 grid place-content-center">
          <img class="w-16 h-10 object-contain" [src]="v.icon" alt="auto" />
        </div>
        <div>
          <div class="flex items-center gap-2">
            <span class="font-semibold text-[#0e1726] dark:text-white">{{ v.brand }} {{ v.vehicle_model }}</span>
            <!-- Semáforo de estado en vivo -->
            <span class="inline-flex items-center gap-1.5 rounded-full px-2 py-0.5 text-[11px] font-semibold"
              [ngClass]="{
                'bg-emerald-500/15 text-emerald-600 dark:text-emerald-400': v.status_live === 'MOVING',
                'bg-red-500/15 text-red-600 dark:text-red-400': v.status_live === 'STOPPED',
                'bg-amber-500/15 text-amber-600 dark:text-amber-400': v.status_live === 'IDLE'
              }"
            >
              <span class="h-2 w-2 rounded-full" [style.background]="statusMeta[v.status_live].hex"></span>
              {{ statusMeta[v.status_live].label }}
            </span>
          </div>
          <div class="text-xs text-gray-500 dark:text-white/70">Placa: {{ v.plate ? (v.plate | uppercase) : '—' }} · {{ v.city.name }}</div>
          <div class="text-[11px] text-gray-400 dark:text-white/50">
            {{ v.status_live === 'MOVING' ? (v.telemetry.speedKmh + ' km/h · ' + v.driver.name) : v.driver.name }}
          </div>
        </div>
      </div>

      <div class="flex items-center gap-3">
        <span *ngIf="v.status" class="rounded-full bg-primary/20 text-primary px-3 py-1 text-xs font-semibold">Activo</span>
        <button
          class="h-10 w-10 grid place-content-center rounded-full hover:bg-gray-100 dark:hover:bg-white/10"
          (click)="toggleMenu(v.id || i.toString(), $event)"
        >
          <icon-horizontal-dots class="h-5 w-5 text-gray-500" />
        </button>

        <!-- Dropdown -->
        <div
          *ngIf="openMenuId === (v.id || i.toString())"
          class="relative"
          (click)="$event.stopPropagation()"
        >
          <div class="absolute right-0 top-10 z-50 w-48 rounded-xl bg-[#1f2937] text-white shadow-lg p-2 space-y-1">
            <button class="flex w-full items-center gap-2 rounded-lg px-3 py-2 hover:bg-white/10 text-sm" (click)="onDetails(v)">
              <icon-info-circle class="h-4 w-4" />
              Detalles
            </button>
            <button class="flex w-full items-center gap-2 rounded-lg px-3 py-2 hover:bg-white/10 text-sm" (click)="onTelemetry(v)">
              <icon-chart-square class="h-4 w-4" />
              Ver  analíticas
            </button>
            <button class="flex w-full items-center gap-2 rounded-lg px-3 py-2 hover:bg-white/10 text-sm text-red-300" (click)="onDelete(v)">
              <icon-trash-lines class="h-4 w-4" />
              Eliminar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Perfil 360 del vehículo (drawer lateral amplio) -->
<app-vehicle-360-profile [vehicleId]="selectedVehicleId" [open]="drawerOpen" (closed)="closeDrawer()"></app-vehicle-360-profile>
